import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/smallgiants.webp';
import screenshot_target from '../../../images/letterfunnel/jeffreyhamelink.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Jeffrey Hamelink"
      firstname="Jeffrey"
      companyname="Small Giants"
      competition="SparkOptimus en Simon-Kucher"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/jeffreyhamelink.js